/**
 * A title bar style control in HTML.
 * @module app/views/PanelHeadingView
 */
import Backbone from "backbone";
import _ from "underscore";
export default Backbone.View.extend({
  template: _.template(
    '<span class="title"><%= title %></span><span class="control-bar left-control-bar"></span><span class="control-bar right-control-bar pull-right"></span><div class="clear"></div>'
  ),

  className: "panel-heading hidden-xs no-select",

  /**
   * Initializes the control.
   * @param  {object} options The options hash.
   * @param {string} options.title The title to display in the bar.
   */
  initialize: function (options) {
    this.options = _.defaults({}, options, {
      title: "",
    });
  },

  render: function () {
    this.$el.html(this.template(this.options));
  },

  /**
   * Gets the title.
   * @return {string} The title.
   */
  getTitle: function () {
    return this.options.title;
  },

  /**
   * Sets the title.
   * @param {string} value The title.
   */
  setTitle: function (value) {
    this.options.title = value;
    this.$(".title").html(value);
  },

  /**
   * Gets a container on the left-hand side in which additional controls may be placed.
   * @return {jquery} The container.
   */
  getLeftControlBar: function () {
    return this.$(".left-control-bar");
  },

  /**
   * Gets a container on the right-hand side in which additional controls may be placed.
   * @return {jquery} The container.
   */
  getRightControlBar: function () {
    return this.$(".right-control-bar");
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/PanelHeadingView.js
// module id = 495
// module chunks = 1